// An order's document (customer {order_invoice}): a Stripe receipt / invoice opens at its URL, the
// seller's own PDF (an order paid on delivery) is saved from the bytes the API answers with.
import { OrderInvoice } from "../storeApi"

export async function openOrderDocument(orderId) {
  const response = await OrderInvoice(orderId).catch((e) => ({ error: e.message }))
  if (response?.invoiceUrl) {
    window.open(response.invoiceUrl, "_blank", "noopener")
    return response
  }
  if (response?.file) {
    const bytes = Uint8Array.from(atob(response.file), (c) => c.charCodeAt(0))
    const url = URL.createObjectURL(new Blob([bytes], { type: response.contentType || "application/pdf" }))
    const link = document.createElement("a")
    link.href = url
    link.download = response.filename || "invoice.pdf"
    document.body.appendChild(link)
    link.click()
    link.remove()
    setTimeout(() => URL.revokeObjectURL(url), 30000)
    return response
  }
  return response
}
